
export default {
  setInitData (state, records) {
    state.allAccounts = records
  },
  setMonthlyCross (state, data) {
    state.allAccounts = data
  },
  setLoadingMCA: (state, loading) => {
    state.loadingRequest = loading
  },
  setbillingProcessStatus: (state, data) => {
    state.billingProcessStatus = data
  },
  updateFinanceList (state, account) {
    let updatedRecordIndex = state.allAccounts.findIndex(record => record.Id === account.Id)
    if (updatedRecordIndex !== -1) {
      state.allAccounts.splice(updatedRecordIndex, 1, { ...account })
    }
  }
}
